import styled from "styled-components";

export const ArticlesContainer = styled.div`
    max-height: 80svh;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 1em 0.25rem 1em 1.5em;
    background-color: whitesmoke;
    @media (max-width: 768px) {
        max-height: 33svh;
    }
`;

export const ArticlesList = styled.ul`
    align-self: stretch;
    overflow: hidden;
    overflow-y: scroll;
    list-style: none;
    margin: 0;
    padding: 1.25rem 1.25rem 0.25rem 0.25rem;
    scroll-behavior: smooth;
`;

export const Button = styled.button`
    width: 100%;
    align-self: stretch;
    padding: 0.5em 0.75em;
    font-size: 1em;
    color: #282828;
    background-color: #ffffff;
    border: 1px solid #282828;
    border-radius: 0;
    cursor: pointer;

    &:hover {
        background-color: #d7d7d7;
    }
`;

export const ButtonGroupVertical = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 0.25em;
`;

export const ContentInfoWrap = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    gap: 0.5em;
`;

export const Heading3 = styled.h3`
    height: 2.5em;
    font-size: 1rem;
    letter-spacing: 0.02ex;
    margin: 0;
    text-overflow: ellipsis fade;
    overflow: hidden;
`;

export const ItemContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.75em;
    width: 100%;
`;

export const ItemContentWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5em;
    width: 100%;
    justify-content: space-between;
`;

export const ItemImageWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Label = styled.p`
    font-size: 0.75em;
    font-weight: bold;
    color: #9e9e9e;
    margin: 0;
`;

export const LabelBold = styled.p`
    margin: 0;
    font-size: 0.75em;
    font-weight: bold;
    color: #9e9e9e;
`;

export const ListItem = styled.li`
    background-color: white;
    padding: 0.75em 0.5em 0.75em 0.5em;
    margin-bottom: 1em;

    &:hover {
        background-color: #e7e7e7;
        cursor: pointer;
    }
`;

export const PopoverContent = styled.div`
    opacity: 0;
    visibility: hidden;
    position: absolute;
    left: 0;
    transform: translate(0, -5px);
    background-color: #ffffff;
    padding: 1em;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
    width: auto;

    &:before {
        position: absolute;
        z-index: -1;
        content: "";
        //right: calc(50% - 10px);
        left: 0;
        top: 0;
        border-style: solid;
        border-width: 0 10px 10px 10px;
        border-color: transparent transparent #ffffff transparent;
        transition-duration: 0.3s;
        transition-property: transform;
    }
`;

export const PopoverWrap = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    display: inline-block;

    &:hover .popover-content {
        z-index: 10;
        opacity: 1;
        visibility: visible;
        transform: translate(0, -5px);
        transition: all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97);
    }
`;

export const PopoverTitle = styled.h4`
    font-size: 1em;
    margin: 0;
`;
